module.exports = __webpack_public_path__ + "676f103cffab6e8a7d0ddb3038541ce6.svg";